import { render, staticRenderFns } from "./InviteesList.vue?vue&type=template&id=2bed9710&scoped=true"
import script from "./InviteesList.vue?vue&type=script&lang=js"
export * from "./InviteesList.vue?vue&type=script&lang=js"
import style0 from "./InviteesList.vue?vue&type=style&index=0&id=2bed9710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bed9710",
  null
  
)

export default component.exports